export enum EnumOpportunityType {
  NEW = 'NEW',
  RENEWAL = 'RENEWAL',
  EVOLUTION = 'EVOLUTION'
}